import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { ToastContainer, toast, style } from 'react-toastify'

import Amplify from 'aws-amplify'

import './Reset.css'
import './App.css'
import './Form.css'

import './polyfill'

import Home from './pages/Home'

import Profile from "./pages/Profile"
import Pros from './pages/Pros'
import Pro from './pages/Pro'
import Embed from './pages/Embed'
import NotFound from './pages/NotFound'
import Header from './components/Header/'
import Footer from './components/Footer/'

import appConfig from './config'

Amplify.configure({
  Auth: {
    identityPoolId: appConfig.identityPoolId,
    region: appConfig.region,
    userPoolId: appConfig.userPoolId,
    userPoolWebClientId: appConfig.clientId,
  },
  Storage: {
    bucket: appConfig.bucket,
    region: appConfig.region,
    identityPoolId: appConfig.identityPoolId,
  },
});

// import Login from './components/Login/'
style({
  width: "220px",
  TOP_RIGHT: {
    top: '5em',
    right: '1em',
  },
});

class App extends Component {
  toastId = null

  notifySave = (msg = null, type) => {
    if (!toast.isActive(this.toastId)) {
      this.toastId = toast(
        msg,
        {
          className: "bt-toast",
          type: toast.TYPE[type],
          autoClose: 2000,
          bodyClassName: `progress-body-${type}`,
          hideProgressBar: true,
          closeButton: false,
        },
      )
    } else {
      toast.update(this.toastId, { render: msg });
    }
  }

  ProfilePage = props => (
    <Profile
      onSave={this.notifySave}
      {...props}
    />
  )

  EmbedPage = props => (
    <Embed
      onCopy={this.notifySave}
      {...props}
    />
  )

  render() {
    return (
      <Router>
        <div>
          <ToastContainer />
          <Header />
          <div className="app">
            <Switch>
              <Route
                exact
                path="/"
                render={props => (
                  <Home {...props} onActiveChange={this.activateSection} />
                )}
              />
              <Route exact path="/profile/edit/:id" render={this.ProfilePage} />
              <Route exact path="/list" component={Pros} />
              <Route exact path="/pro/:id" component={Pro} />
              <Route exact path="/embed/:version/:id/:locale?" component={this.EmbedPage} />
              <Route component={NotFound} />
            </Switch>
          </div>
          <Footer />
        </div>
      </Router>
    )
  }
}


export default App



// WEBPACK FOOTER //
// ./src/App.js